import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  requestGetStudentByPhone,
  requestGetEvaluationHistory,
} from "../utils/resource";
import { EXERCISES } from "../utils/evaluationUtils";
import HistoryModal from "./HistoryModal";
import Ranking from "./Ranking";

import "../styles/StudentArea.css";
import videoBg from "../assets/video_web.mp4";
import logo from "../imgs/logo-jessica-2.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faArrowLeft,
  faTrophy,
} from "@fortawesome/free-solid-svg-icons";

const StudentArea = () => {
  const [studentIdInput, setStudentIdInput] = useState("");
  const [student, setStudent] = useState(null);
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isRankingVisible, setIsRankingVisible] = useState(false);

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    const truncatedDigits = digits.slice(0, 11);
    let formatted = "";
    if (truncatedDigits.length > 0) {
      formatted = `(${truncatedDigits.slice(0, 2)}`;
    }
    if (truncatedDigits.length >= 3) {
      formatted = `(${truncatedDigits.slice(0, 2)}) ${truncatedDigits.slice(
        2,
        7
      )}`;
    }
    if (truncatedDigits.length >= 8) {
      formatted = `(${truncatedDigits.slice(0, 2)}) ${truncatedDigits.slice(
        2,
        7
      )}-${truncatedDigits.slice(7, 11)}`;
    }
    return formatted;
  };

  const handlePhoneChange = (e) => {
    setStudentIdInput(formatPhoneNumber(e.target.value));
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const phone = studentIdInput;

    if (phone.length < 10) {
      setError("Por favor, digite um telefone válido com DDD.");
      return;
    }
    setIsLoading(true);
    setError("");
    setStudent(null);
    setHistory([]);

    const studentResult = await requestGetStudentByPhone(phone);
    if (studentResult.status === "success") {
      const foundStudent = studentResult.data;
      setStudent(foundStudent);
      const historyResult = await requestGetEvaluationHistory(foundStudent.id);
      if (historyResult.status === "success") {
        setHistory(
          historyResult.data.sort((a, b) => new Date(a.date) - new Date(b.date))
        );
      } else {
        setError(historyResult.message);
      }
    } else {
      setError("Nenhum aluno encontrado com este telefone.");
      setStudent(null);
    }
    setIsLoading(false);
  };

  const handleReset = () => {
    setStudentIdInput("");
    setStudent(null);
    setHistory([]);
    setError("");
  };

  return (
    <>
      <div className="auth-video-container">
        <video
          src={videoBg}
          autoPlay
          loop
          muted
          playsInline
          className="auth-video-bg"
        />
        <div className="auth-overlay"></div>
      </div>

      <div className="auth-container">
        <header className="auth-header">
          <Link to="/" className="auth-back-button">
            <FontAwesomeIcon icon={faArrowLeft} /> Voltar
          </Link>
        </header>

        <img src={logo} alt="Logo" className="auth-logo" />

        <div className="auth-card">
          <h2 className="auth-card-title">Área do Aluno</h2>
          <p className="auth-card-subtitle">
            Digite seu telefone para ver seu histórico de avaliações.
          </p>
          <form onSubmit={handleSearch} className="auth-form">
            <input
              type="tel"
              placeholder="(00) 00000-0000"
              value={studentIdInput}
              onChange={handlePhoneChange}
              className="auth-input"
              maxLength="15"
            />
            <button
              type="submit"
              disabled={isLoading}
              className="auth-btn-submit"
            >
              {isLoading ? (
                "Buscando..."
              ) : (
                <>
                  <FontAwesomeIcon icon={faSearch} /> Buscar
                </>
              )}
            </button>
          </form>
          {error && <p className="auth-error-message">{error}</p>}
        </div>

        {false && (
          <>
            <button
              className="pilates-sa-ranking-toggle-btn"
              onClick={() => setIsRankingVisible(!isRankingVisible)}
            >
              <FontAwesomeIcon icon={faTrophy} />
              {isRankingVisible ? "Ocultar Ranking" : "Ver Top 10 Pilateiros"}
            </button>

            {isRankingVisible && (
              <div className="pilates-sa-ranking-wrapper">
                <Ranking />
              </div>
            )}
          </>
        )}

        <footer className="auth-footer">
          <p>© 2026 - Todos os direitos reservados.</p>
        </footer>
      </div>

      {student && (
        <HistoryModal
          show={!!student}
          onClose={handleReset}
          history={history}
          studentName={student.name}
          exercises={EXERCISES}
        />
      )}
    </>
  );
};

export default StudentArea;
